import { RegistrationState } from "./RegistrationState";
import { RegStateValidate } from "./RegStateValidate";

/** Etat : Traitement d'un token d'enregistrement */
export class RegStateRegister extends RegistrationState{
    public async Next(): Promise<void> {
        /** Initialisation des messages affichés */
        this.context.Title = this.context.$t('RegisterTitle').toString();
        this.context.FirstExplainLine = this.context.$t('RegisterFirstExplainLine').toString();
        this.context.SecondExplainLine = this.context.$t('RegisterSecondExplainLine').toString();
        this.context.SubmitText = this.context.$t('RegisterSubmitText').toString();
        this.context.ShowLogin = false;

        this.context.ValidateTitle = this.context.$t('ValidateTitleRegistration').toString();
        this.context.ValidateSuccessMessage = this.context.$t('ValidateSuccessRegistration').toString();
        this.context.ValidateFailMessage = this.context.$t('ValidateFailRegistrationTokenExpired').toString();

        /** Intialisation des champs de saisie */
        this.context.Login = this.analyseToken.Login;
        this.context.Password = "";
        
        this.context.TransitionTo(new RegStateValidate(this))
    }
}